import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

const splideSetting = (): void => {
  const splide1 = new Splide('.p-service-splide-splide', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '1.8rem',
    pagination: true,
    arrows: true,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
  }).mount();

  const splide2Elements: any = document.querySelectorAll('.p-customer__images-splide') || null;
  if (splide2Elements) {
    splide2Elements.forEach((element: HTMLElement) => {
      const splide2 = new Splide(element, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '2rem',
        pagination: true,
        arrows: false,
        // autoplay: true,
        // interval: 5000,
        pauseOnHover: false,
      }).mount();
    });
  }
};

export default splideSetting;
